import { useState } from 'react';
import useCreate from '../useCreate';
import useGet from '../useGet';
import toast from 'react-hot-toast';

function useProductRearrange() {
  // States for rearrangement modal
  const [isRearrangeModalOpen, setRearrangeModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // Function to handle opening the modal
  const handleOpenRearrangeModal = () => {
    setRearrangeModalOpen(true);
  };

  // Function to close the modal
  const handleCloseRearrangeModal = () => {
    setRearrangeModalOpen(false);
    setProducts([]);
  };

  // Get all products
  const { data } = useGet({
    url: 'product-position-list',
    enabled: isRearrangeModalOpen,
    onSuccess: (response) => {
      if (response?.data && Array.isArray(response.data)) {
        // Sort products by current position
        const sortedProducts = [...response.data].sort((a, b) => {
          // Convert string positions to numbers for sorting
          return parseInt(a.position) - parseInt(b.position);
        });
        setProducts(sortedProducts);
      }
    },
    onError: (err) => {
      toast.error(`Error loading products: ${err?.message || 'Unknown error'}`, {
        position: "top-right",
        duration: 3000,
      });
    }
  });

  // Loading state
  const isLoading = data?.isLoading || data?.isFetching;

  // Function to handle rearrangement on drag
  const handleOrderChange = (newOrder) => {
    setProducts(newOrder);
  };

  // Save product positions
  const { setDataToServer: saveProductPositions } = useCreate({
    url: "product-positioning",
    refreshUrl: "get-product-list",
    onSuccess: () => {
      toast.success("Product order updated successfully", {
        position: "top-right",
        duration: 3000,
      });
      setRearrangeModalOpen(false);
      setIsSaving(false);
    },
    onError: (err) => {
      toast.error(`Error updating product order: ${err?.message || 'Unknown error'}`, {
        position: "top-right",
        duration: 3000,
      });
      setIsSaving(false);
    },
  });

  // Function to save the new order
  const handleSaveOrder = () => {
    setIsSaving(true);
    
    // Payload for saving product positions
    const positionData = products.map((product, index) => ({
      product_id: String(product.product_id),
      position: String(index + 1)
    }));
    
    saveProductPositions.mutate({ data: positionData });
  };

  return {
    isRearrangeModalOpen,
    products,
    isLoading,
    isSaving,
    handleOpenRearrangeModal,
    handleCloseRearrangeModal,
    handleOrderChange,
    handleSaveOrder
  };
}

export default useProductRearrange;
